/**
 * The currently supported whitepapers; may be replaced by CMS config in future
 */
export type WhitepaperSlugs =
  | 'job-market-report-australia'
  | 'job-market-report-new-zealand'
  | 'cv-template'
  | 'international-doctor-guide'
  | 'interview-guide'
  | 'locum-guide-2026';

export type OptionalWhitepaperSlug = WhitepaperSlugs | null;

/**
 * Data about each whitepaper
 */
export type WhitepaperMetadata = {
  // The name that Salesforce knows this whitepaper by. To be displayed to users.
  name: string;
  // The value prop of this whitepaper. To be displayed to users.
  description: string;
  // The text to be displayed over a banner image
  textOverlay: string[];
};

/**
 * Data about all supported whitepapers
 */
export const whitepapers: Map<WhitepaperSlugs, WhitepaperMetadata> = new Map([
  [
    'job-market-report-australia',
    {
      name: 'Job Market Report Australia',
      description:
        'Download our Free Australian Doctor Job Market Report. Free job market report packed with information for doctors in Australia. Find out what is having an impact on Australian healthcare today, where the work is, what specialties are in demand, and average pay rates for locum and permanent roles across the country.',
      textOverlay: [
        'Find out the',
        'hottest locations',
        'and highest rates',
        'for doctors in',
        'Australia right now.',
      ],
    },
  ],
  [
    'job-market-report-new-zealand',
    {
      name: 'Job Market Report NZ',
      description:
        'Download our Free New Zealand Doctor Job Market Report. Free job market report packed with information for doctors in New Zealand. Find out what is having an impact on New Zealand healthcare today, where the work is, what specialties are in demand, and average pay rates for locum and permanent roles across the country.',
      textOverlay: [
        'Find out the best',
        'rates, and in-demand',
        'locations for doctors in',
        'New Zealand right now.',
      ],
    },
  ],
  [
    'cv-template',
    {
      name: 'CV Template',
      description:
        'Download our Free Editable Doctor CV Template. A doctor’s curriculum vitae is one of the most important tools in their job search arsenal. This CV template, specifically designed for doctors, will help make sure you have everything you need on yours to apply for (and get) great new roles',
      textOverlay: ["Let's ensure", 'your CV is', 'right for the job.'],
    },
  ],
  [
    'international-doctor-guide',
    {
      name: 'INTL Guide',
      description:
        'Your free Guide to Working Down Under as an International Medical Graduate is packed with information for IMGs looking to make the move to Australia or New Zealand. Find out what residence pathway is right for you, where the work is and what the rates are, and what your new lifestyle down under could be like.',
      textOverlay: [
        'Find out everything',
        'you need to know',
        'about working as a doctor',
        'in Australia and New Zealand',
      ],
    },
  ],
  [
    'interview-guide',
    {
      name: 'Interview Guide',
      description:
        'Download our Free Doctor Interview Guide. Packed with common questions and answers to help you nail your next interview.',
      textOverlay: [
        'Get the insider',
        'tips and tricks',
        'to nail your',
        'next doctor job interview.',
      ],
    },
  ],
  [
    'locum-guide-2026',
    {
      name: 'Locum Guide 2026',
      description:
        'Download our Free Locum Guide 2026. Everything you need to know about locum work in Australia and New Zealand, including rates, locations, and how to get started.',
      textOverlay: [
        'Your complete guide',
        'to locum work',
        'in Australia and',
        'New Zealand in 2026.',
      ],
    },
  ],
]);
